import { render, staticRenderFns } from "./cGovernance.vue?vue&type=template&id=33be4b30&scoped=true"
import script from "./cGovernance.vue?vue&type=script&lang=js"
export * from "./cGovernance.vue?vue&type=script&lang=js"
import style0 from "./cGovernance.vue?vue&type=style&index=0&id=33be4b30&prod&scoped=true&lang=css"
import style1 from "./cGovernance.vue?vue&type=style&index=1&id=33be4b30&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33be4b30",
  null
  
)

export default component.exports